import * as React from "react";
import theme from "styles/theme";
import { SIZE_TOTALS_IDENTIFIER } from "./helpers";

export class CustomPinnedRowRenderer extends React.Component<any, any> {
    renderValue = (value: string, params: any) => {
        const { data, valueFormatted } = this.props;
        if (data?.type === SIZE_TOTALS_IDENTIFIER && valueFormatted) {
            return valueFormatted;
        }
        const { splitValue, splitCharacter = "/" } = params || {};
        if (!splitValue || !value || typeof value !== "string") {
            return value;
        }

        const values = value.split(splitCharacter);
        if (values.length !== 2) {
            return value;
        }

        return (
            <>
                <span style={values[0].trim() !== values[1].trim() ? { color: theme.palette.error } : null}>
                    {values[0]}
                </span>
                {splitCharacter}
                <span style={{ fontWeight: "bold" }}>{values[1]}</span>
            </>
        );
    };

    render = ({ style, value, colDef } = this.props) => (
        <div style={style}>{this.renderValue(value, colDef.cellRendererParams)}</div>
    );
}

export class CustomPinnedBulkRowRenderer extends React.Component<any, any> {
    renderValue = (value: string, params: any) => {
        const { splitValue, splitCharacter = "/" } = params || {};
        if (!splitValue || !value) {
            return value;
        }

        const values = value.split(splitCharacter);
        if (!values.length || values.length > 2) {
            return value;
        }

        return values[1];
    };

    render = ({ style, value, colDef } = this.props) => (
        <div style={style}>{this.renderValue(value, colDef.cellRendererParams)}</div>
    );
}
